export default __webpack_public_path__ + "static/media/contact-left-bg.20021d09.png";